import React from 'react';
import ftrLogo from "../../assets/imgs/pratham_logo.jpg";
import ftrLogo1 from "../../assets/imgs/logo/ftr-logo.JPG";
import "../../assets/css/app.css";
import fb from "../../assets/imgs/icons/fb_icon.svg";
import insta from "../../assets/imgs/icons/insta_icon.svg";
import link from "../../assets/imgs/icons/link_icon.svg";
import "./Footer.css";
import { NavLink } from 'react-router';
import { useState } from 'react';
import { motion } from 'framer-motion';
import Enquiry from "../Enquiry/Enquiry";
import { AnimatePresence } from 'framer-motion';
import { useEffect } from 'react';

function Footer() {



const [showPopup, setShowPopup] = useState(false);
 const [menuOpen, setMenuOpen] = useState(false);
const handlePopupOpen = () => setShowPopup(true);
const handlePopupClose = () => setShowPopup(false);
const handleNavClick = () => {
  setMenuOpen(false); 
};
  return (
    <div className='ftrs'>
      <div className="maxW">
        <div className="ftrsMn">
          <div className="logo ftrLogo">
          <NavLink to="/ " className="hme">
                <button  className='hdrLogo'>
                  <img src={ftrLogo} alt="Pratham Style" />
                </button>
                <button  className='ftrLgs'>
                  <img src={ftrLogo1} alt="Pratham Style" />
                </button>
              </NavLink>
          </div>

          <div className="ftrList">
            <NavLink to={"/"} className="hme">HOME</NavLink>
            <NavLink to={"/AboutUs"} className="hme">ABOUT US</NavLink>
            <NavLink to={"/ContactUs"} className="hme">CONTACT US</NavLink>
            <NavLink to={"/Enquiry"} className="hme">ENQUIRY</NavLink>
             
          </div>
        </div>
        <div className="ftrBm">
          <div className='ftBLft'>
            <p>© {new Date().getFullYear()}, Pratham Style. All right reserved. Developed by <a href='https://www.cfcs.co.in/' target='_blank'>CFCS</a></p>
          </div>
          <div className="ftBRyt">
            <div className='soWrp'>
              <img src={fb} alt="Facebook" />
              <img src={link} alt="LinkedIn" />
              <img src={insta} alt="Instagram" />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Footer